export const CURRENCY_CLASSES = {
  USD: 'usd',
  EUR: 'eur',
  RUB: 'rub',
  KZT: 'kzt',
  BYR: 'byn',
  BYN: 'byn',
};

export const DEFAULT_CURRENCY_CLASS = 'rub';

export const CREDIT_PERCENT = 0.3;

export const PRICE_MAP_LABEL = [
  'RUB',
  'USD',
  'BYN',
  'TNG',
];

export const PRICE_MAP_VALUE = {
  'RUB': 0,
  'USD': 1,
  'EUR': 1,
  'BYR': 2,
  'KZT': 3,
  'TNG': 3,
};

export const CURRENCY_MAP_ICON = {
  'RUB': '₽',
  'USD': '$',
  'EUR': '€',
  'BYN': 'Br.',
  'BYR': 'Br.',
  'TNG': '₸',
  'KZT': '₸'
};